// extracted by mini-css-extract-plugin
export default {"userRoundel":"userRoundel_userRoundel__ra5gR","initials":"userRoundel_initials__yFj9f","empty":"userRoundel_empty__iCMdZ","large":"userRoundel_large__ajTES"};